export default {
  "general": {
    "actions": "Aktionen",
    "back": "Zurück",
    "blank": "Leer",
    "doExport": "Exportieren",
    "edit": "Bearbeiten",
    "language": "Sprache",
    "loadMore": "Weitere laden",
    "monthNames": [
      "Januar",
      "Februar",
      "März",
      "April",
      "Mai",
      "Juni",
      "Juli",
      "August",
      "September",
      "Oktober",
      "November",
      "Dezember"
    ],
    "filterBy": "Nach {property} filtern",
    "noData": "Keine Einträge vorhanden",
    "noPageContentYet": "Diese Seite enthält noch keinen Inhalt",
    "notYetImplemented": "Diese Funktion ist zurzeit noch nicht verfügbar",
    "nothingGiven": "Keine Angabe",
    "no": "Nein",
    "okay": "Okay",
    "optional": "Optional",
    "pleaseSelect": "Bitte wählen...",
    "table": {
      "reload": "Neu Laden",
      "loading": "Lade Einträge"
    },
    "today": "Heute",
    "yesterday": "Gestern",
    "tooManyResultsToExport": "Export kann nicht erstellt werden, da zu viele Suchergebnisse vorhanden sind. Bitte grenzen Sie die Suche ein.",
    "welcome": "Willkommen bei {appName}",
    "yes": "Ja",
    "startingFrom": "ab",
    "month": "Monat",
    "year": "Jahr",
    "yearDoubleDigit": "Jahr (zweistellig)",
    "monthYear": "Monat / Jahr",
    "monthNumber": "Monat (Nummer)",
    "miscellaneous": "Sonstiges",
    "save": "Speichern",
    "cancel": "Abbrechen",
    "createdAt": "Erstellt am {date}",
    "delete": "Löschen",
    "deleted": "Gelöscht",
    "more": "Mehr",
    "send": "Senden",
    "renew": "Erneuern",
    "action": "Aktion",
    "isLoading": "Wird geladen",
    "sendToOwners": "",
    "tableFilterSearch": "Suchen...",
    "error": "Fehler",
    "amount": "Betrag",
    "download": "Herunterladen",
    "couldNotDownloadSepa": "SEPA Datei konnte nicht heruntergeladen werden",
    "dateRange": "Zeitraum",
    "show": "Ansehen",
    "unknown": "Unbekannt",
    "dateTo": "Bis",
    "restore": "Wiederherstellen",
    "moreAvailableWithSearch": "{numberOfAvailableItems} weitere Einträge über Suchtext",
    "pageNotFound": "Seite konnte nicht gefunden werden",
    "only": "Nur",
    "dragAndDropReorderTitle": "Klicken und Ziehen, um die Reihenfolge zu ändern",
    "rightClickForMoreOptions": "Rechtsklick für mehr Optionen",
    "openInStayin": "In Stayin öffnen",
    "showAll": "Zeige alle",
    "close": "Schließen",
    "report": "Bericht",
    "notes": "Notizen",
    "intervalMonthly": "Monatlich",
    "intervalBiMonthly": "Alle zwei Monate",
    "intervalQuarterly": "Vierteljährlich",
    "intervalBiYearly": "Halbjährlich",
    "intervalYearly": "Jährlich"
  },
  "error": {
    "error": "Fehler",
    "general": "Es ist ein Fehler aufgetreten",
    "pleaseCheckYourInput": "Bitte überprüfen Sie Ihre Eingaben",
    "serverConnection": "Der Server ist zurzeit nicht erreichbar",
    "unexpectedErrorOccured": "Ein unbekannter Fehler ist aufgetreten",
    "unknownError": "Unbekannter Fehler"
  },
  "auth": {
    "account": "Benutzerkonto",
    "email": "E-Mail",
    "errorInvalidCredentials": "Fehler: Benutzername oder Passwort ungültig",
    "errorServerUnreachable": "Fehler: Server konnte nicht erreicht werden",
    "login": "Anmelden",
    "password": "Passwort",
    "logout": "Abmelden",
    "errorOnLogout": "Fehler beim Abmelden"
  },
  "pages": {
    "Settlements": "Abrechnungen"
  },
  "request": {
    "errorGeneral": "Es ist ein Fehler aufgetreten.\nBitte versuchen Sie es erneut.",
    "errorNotConnected": "Es ist ein Fehler aufgetreten.\nSind Sie mit dem Internet verbunden?",
    "retry": "Erneut versuchen"
  },
  "validationErrors": {
    "required": "Bitte dieses Feld ausfüllen",
    "maxCharacters": "Kann maximal {maxCharacters} Zeichen lang sein",
    "negative": "Nur negative Beträge erlaubt"
  },
  "dashboard": {
    "dashboard": "Dashboard",
    "numberOfOpenCancellations": "Keine offenen Stornierungen | Offene Stornierung | Offene Stornierungen"
  },
  "bankAccount": {
    "blz": "BLZ",
    "bankName": "Bankname",
    "owner": "Kontoinhaber",
    "accountNumber": "Kontonummer",
    "iban": "IBAN",
    "bic": "BIC",
    "bankDetails": "Bankverbindung"
  },
  "email": {
    "statusSent": "Versendet",
    "titleStatusSent": "E-Mail wurde versendet",
    "titleStatusSentAt": "E-Mail wurde am {successfullySentAt} versendet",
    "titleStatusPending": "E-Mail Versand erfolgt in Kürze",
    "titleStatusFailed": "Es ist ein Fehler beim Versand aufgetreten"
  },
  "object": {
    "maxGuests": "Gast max. | Gäste max.",
    "object": "Objekt | Objekte",
    "objectsAndGroups": "Objekte & Gruppen",
    "rooms": "Raum | Räume",
    "new": "Neues Objekt",
    "mainInformation": "Objekt Information",
    "name": "Name",
    "group": "Gruppe",
    "address": "Adresse",
    "capacity": "Kapazität",
    "petsAllowed": "Tiere erlaubt",
    "owner": "Eigentümer",
    "ownerEmail": {
      "sendingEnabled": "E-Mail bei neuer Buchung",
      "attachContract": "Mietvertrag anhängen"
    },
    "ownerEmailSettings": {
      "doNotSend": "Nein",
      "sendWithoutContract": "Ja, ohne Mietvertrag Link",
      "sendWithContract": "Ja, mit Mietvertrag Link"
    },
    "removeFromGroup": "Aus Gruppe entfernen",
    "withoutGroup": "Objekte ohne Gruppe",
    "assignGroups": "Gruppen zuweisen",
    "city": "Ort",
    "status": "Objekt Aktiv",
    "statusHelp": "Falls deaktviert, wird für dieses Objekt keine Abrechnung erzeugt",
    "noAutoCheck": "Keine automatische Überprüfung",
    "noAutoCheckHelp": "Falls aktviert, wird beim Anlegen odern Erneuern einer Objektabrechnung diese nicht automatisch überprüft",
    "requiresManualEmail": "Nicht im E-Mail Paket versenden",
    "requiresManualEmailHelp": "Falls aktviert, wird die Eigentümer E-Mail für eine Objektabrechnung nicht mit dem E-Mail-Paket versendet und muss einzeln versendet werden",
    "incomeBank": "Bankdetails",
    "showInactive": "Zeige inaktive Objekte",
    "objectId": "Objekt-Nr.",
    "street": "Straße",
    "zipcode": "Postleitzahl",
    "country": "Land",
    "settingsGeneral": "Allgemeine Einstellungen",
    "settlementNotes": "Abrechnungsnotizen",
    "settlementNotesHelp": "Hinweise, die bei der Abrechnung beachtet werden müssen. Beispiel: \"ET möchte Abrechnung per Post\".",
    "sendSettlementWithZeroAmount": "Sende Nullrechnungen",
    "sendSettlementWithZeroAmountHelp": "Falls aktiviert, erhält der Eigentümer Abrechnungen, die einen Saldo von 0,- aufweisen",
    "nameOfObject": "Name des Objekts"
  },
  "objectGroup": {
    "objectGroup": "Objekt-Gruppe | Objekt-Gruppen",
    "new": "Neue Objekt-Gruppe",
    "mainSettings": "Grundeinstellungen",
    "name": "Name",
    "description": "Beschreibung",
    "nameHelp": "",
    "currency": "Währung",
    "settlementOption": "Art der Abrechnung",
    "vatCommission": "MwSt. für Provision (%)",
    "vatRent": "MwSt. in Miete (%)",
    "commission": "Provision (%)",
    "basis": "Basis",
    "commissionIncludeAdditional": "Provision enthält Zusätzliche Leistungen",
    "commissionIncludePets": "Provision enthält Haustiere",
    "commissionSubheading": "Provision",
    "confirmDelete": "Sind Sie sicher, dass Sie die Objekt-Gruppe \"{name}\" löschen möchten?",
    "delete": "Objekt-Gruppe löschen",
    "amounts": "Beträge",
    "commissionAdd": "Zusätzliche Provisionsgebühr",
    "objectCount": "Objekte",
    "finalCleaningDefault": "Grundpreis Endreinigung",
    "datevAccount": "DATEV Konto",
    "settlementCutoffDayOfMonth": "Stichtag Verschiebung von Buchungen in den nächsten Monat",
    "settlementCutoffDayOfMonthHelp": "Alle Buchungen, deren Abreisedatum nach diesem Tag im Monat liegt, sollen in den nächsten Abrechnungsmonat geschoben werden. Beispiel: Wenn 27. gewählt, dann werden Buchungen mit Abreise 28. oder später in den nächsten Monat verschoben.",
    "commissionBasis": "Berechnungsgrundlage für Provision",
    "sortObjectGroups": "Objekt-Gruppen frei sortieren",
    "sortSave": "Sortierung speichern",
    "showObjectsInGroup": "Zeige Objekte in Gruppe {group}",
    "settlementSettings": "Abrechnungs-Einstellungen",
    "settlementPdf": {
      "page": "Seite {pageNumber}",
      "coverSheet": "Deckblatt",
      "headline": "Überschrift",
      "addContent": "Inhalt hinzufügen",
      "addText": "Text hinzufügen",
      "addPage": "Seite hinzufügen"
    },
    "caretakers": "Objektverwalter",
    "caretakersHelp": "Objektverwalter haben Zugriff auf die Buchungen der Objekte aus dieser Gruppe",
    "settlementOptionTwoSettlements": "Zwei Abrechnungen",
    "settlementOptionOneSettlementAfterArrival": "Eine Abrechnung, Prov. nach Anreise",
    "settlementOptionOneSettlementAfterDeparture": "Eine Abrechnung, Prov. nach Abreise",
    "rentBasisRent": "Mietbetrag",
    "settlementCommissionAddPerBooking": "Pro Buchung",
    "settlementAmountOptionGross": "Bruttobeträge",
    "settlementAmountOptionNet": "Nettobeträge",
    "settlementCutoffDayOfMonthDoNotShift": "Nie verschieben",
    "create": "Objekt-Gruppe anlegen",
    "gotoObjectGroup": "Zur Objekt-Gruppe gehen"
  },
  "owner": {
    "name": "Name",
    "address": "Adresse",
    "email": "E-Mail",
    "phoneNumber": "Telefonnummer",
    "taxNumber": "Steuernummer",
    "sepaMandateId": "SEPA Mandats-ID",
    "sepaMandateSignedAt": "SEPA Mandats-Unterzeichnungs Datum"
  },
  "settlement": {
    "settlement": "Abrechnung | Abrechnungen",
    "year": "Jahr",
    "commissionNet": "Provision mtl. Netto",
    "commissionGross": "Provision mtl. Brutto",
    "openCommission": "Provision Netto vorläufig",
    "saldoTotal": "Saldo",
    "saldoTotalWithOpenBookings": "Saldo (inkl. offene Buchungen)",
    "showObjectsInGroup": "Zeige einzelne Abrechnungen",
    "month": "Monat",
    "status": "Status",
    "settlementObject": "Objektabrechnung|Objektabrechnungen",
    "titleIsChecked": "Wurde geprüft",
    "titleIsNotChecked": "Wurde noch nicht geprüft",
    "titleIsSent": "Wurde am {successfullySentAt} an den Eigentümer versendet",
    "titleIsUnknownSent": "Wurde an den Eigentümer versendet",
    "titleIsNotSent": "Wurde noch nicht an Eigentümer versendet",
    "titleIsTransferFileDownloaded": "Zahlungs-Datei wurde heruntergeladen",
    "titleIsNotTransferFileDownloaded": "Zahlungs-Datei wurde noch nicht heruntergeladen",
    "create": "Neue Abrechnung erzeugen",
    "generatePreview": "Abrechnungs-Vorschau erzeugen",
    "preview": "Abrechnungs-Vorschau",
    "new": "Neue Abrechnung",
    "delete": "Abrechnung löschen",
    "objectsDoNotBelongToGroup": "{numberOfObjectsWithoutGroup} Objekt ist noch keiner Objekt-Gruppe zugeordnet|{numberOfObjectsWithoutGroup} Objekte sind noch keiner Objekt-Gruppe zugeordnet",
    "bookingValidationErrorCodes": "Hinweise",
    "optionNothing": "Keine Aktion",
    "optionNothingTitle": "Noch nichts unternehmen",
    "optionShiftTitle": "In den nächsten Monat verschieben",
    "optionCloseTitle": "Schließen und in die Abrechnung einfügen",
    "missingConsumption": "Es wurden noch nicht alle Verbrauchswerte eingetragen",
    "checkoutInFuture": "Abreise befindet sich in der Zukunft",
    "totalDoNotMatch": "Der Gesamtbetrag stimmt nicht mit den einzelnen Werten überein",
    "dueDateAfterCheckin": "Das Mietzahlungsdatum liegt nach dem Anreisedatum",
    "mailNotYetSentToOwner": "Benachrichtigungs Email wurde noch nicht an den Eigentümer versendet",
    "notePresent": "Es sind Notizen vorhanden",
    "noNonDepositPayment": "Es sind keine gültigen Zahlungen vorhanden",
    "bookingsWithFatalErrors": "{numberOfBookings} Buchung mit Fehlern vorhanden|{numberOfBookings} Buchungen mit Fehlern vorhanden",
    "bookingsWillBeAutoShifted": "{numberOfBookings} Buchung wird automatisch verschoben|{numberOfBookings} Buchungen werden automatisch verschoben",
    "bookingsWillBeAutoClosed": "{numberOfBookings} Buchung wird automatisch geschlossen und in die Abrechnung eingeführt|{numberOfBookings} Buchungen werden automatisch geschlossen und in die Abrechnung eingeführt",
    "bookingsRequireManualAction": "Für {numberOfBookings} Buchung muss noch eine Aktion gewählt werden|Für {numberOfBookings} Buchungen müssen noch Aktionen gewählt werden",
    "notesCaretaker": "Notiz Objektverwalter",
    "updateBookings": "Buchungen aktualisieren",
    "noFurtherActionsRequired": "Es sind keine weiteren Aktionen notwendig",
    "downloadPdf": "PDF herunterladen",
    "downloadDatevCsv": "DATEV CSV herunterladen",
    "downloadSepa": "SEPA herunterladen",
    "downloadSepaCt": "SEPA Überweisungen herunterladen",
    "downloadSepaDd": "SEPA Lastschriften herunterladen",
    "sendToOwners": "An Eigentümer senden",
    "downloadDatevCsvPackage": "DATEV Paket herunterladen",
    "couldNotDownloadDatevCsv": "DATEV CSV konnte nicht heruntergeladen werden",
    "titleIsDatevDownloaded": "DATEV CSV wurde heruntergeladen",
    "titleIsNotDatevDownloaded": "DATEV CSV wurde noch nicht heruntergeladen",
    "isGenerating": "Die Abrechnung für {monthName} {year} wird erzeugt. Dies kann einige Sekunden in Anspruch nehmen.",
    "effectiveDate": "Stand: {date}",
    "downloadOpenCommission": "Download Nettoprovision aller offenen Buchungen ab {date} als CSV.",
    "sendToOwnerSubject": "Ihre Abrechnung für {monthName} {year}",
    "ownerName": "Name des Eigentümers",
    "objectName": "Objekt-Name",
    "objectStreet": "Objekt Straße",
    "objectZipcode": "Objekt PLZ",
    "objectCity": "Objekt Stadt",
    "settlementMonth": "Abrechnung Monat",
    "settlementYear": "Abrechnung Jahr",
    "setNotChecked": "Als noch nicht geprüft markieren",
    "setChecked": "Als geprüft markieren",
    "setNotSent": "Als nicht gesendet markieren",
    "setSent": "Als gesendet markieren",
    "filterByChecked": "Nach geprüft filtern...",
    "isChecked": "Geprüft",
    "isNotChecked": "Noch nicht geprüft",
    "filterBySent": "Nach versendet filtern...",
    "isSent": "Versendet",
    "isNotSent": "Noch nicht versendet",
    "filterByDatev": "Nach DATEV filtern...",
    "filterBySepa": "Nach SEPA filtern...",
    "isDownloaded": "Bereits heruntergeladen",
    "isNotDownloaded": "Noch nicht heruntergeladen",
    "confirmRenew": "Sind Sie sicher, dass Sie die Abrechnung erneuern möchten? Dadurch werden noch nicht geprüfte Objektabrechnungen gelöscht und neu generiert.",
    "confirmDelete": "Sind Sie sicher, dass Sie die Abrechnung löschen möchten?",
    "sendToOwnersHelp": "Zurzeit sind keine Abrechnungen vorhanden, die per E-Mail versendet werden können. | Es wird 1 Abrechnung per E-Mail versendet, die bereits geprüft und noch nicht versendet wurde. | Es werden {count} Abrechnungen per E-Mail versendet, die bereits geprüft und noch nicht versendet wurden.",
    "settlementObjects": {
      "renew": "Objektabrechnung erneuern",
      "titleRenewError": "Nicht alle Objektabrechnungen wurden erneuert"
    },
    "confirmObjectRenew": "Sind Sie sicher, dass Sie diese Objektabrechnung erneuern möchten? Dadurch wird der Status komplett zurück gesetzt.",
    "downloadPdfPackage": "PDF Paket herunterladen",
    "settleUpBookings": "Buchungen abrechnen",
    "openBookingsAvailable": "Es ist noch eine offene Buchungen vorhanden | Es sind noch {numberOfOpenBookings} offene Buchungen vorhanden",
    "missingObjectsForSettlement": "Für das folgende Objekt wurde noch keine Abrechnung erzeugt | Für die folgenden {numberOfObjects} Objekte wurde noch keine Abrechnung erzeugt",
    "createMissingSettlementObjects": "Abrechnung erstellen | Abrechnungen erstellen",
    "statusOpen": "Offen",
    "statusCompleted": "Abgeschlossen",
    "settleUpBookingsHelp": "Zeigt eine Liste der noch offenen Buchungen für diesen Monat an, für die eine Entscheidung getroffen werden muss (schließen, verschieben, ...) Sollten Buchungen geschlossen werden, werden betroffene Abrechnungen erneuert",
    "downloadPdfPackageHelp": "Lädt alle Abrechnungen als PDF Paket (Zip-Datei) herunter, die in diesem Monat erzeugt wurden",
    "downloadDatevCsvPackageHelp": "Lädt eine DATEV-CSV Datei aller Abrechnungen herunter, die bereits geprüft und noch nicht heruntergeladen wurden",
    "sendToOwnersActionHelp": "Versendet alle geprüften Abrechnungen per E-Mail an die Eigentümer, die noch nicht versendet wurden. Es ist möglich, den Inhalt vor Senden der E-Mail anzupassen.",
    "downloadSepaHelp": "Lädt eine SEPA-XML Datei aller Abrechnungen herunter, die zur Überweisung bzw. Lastschrifteinzug bereit sind, und zuvor noch nicht heruntergeladen wurden.",
    "monthYearHelp": "Monat und Jahr der Abrechnung"
  },
  "booking": {
    "booking": "Buchung | Buchungen",
    "bookingId": "Buchungs-Nr.",
    "checkinAt": "Anreise",
    "checkin": "Anreise | Anreisen",
    "checkinDate": "Datum der Anreise",
    "checkoutAt": "Abreise",
    "checkout": "Abreise | Abreisen",
    "checkoutDate": "Datum der Abreise",
    "shift": "Verschieben",
    "close": "Schließen",
    "closeHelpText": "Beim Schließen wird automatisch versucht eine Rückzahlung anzulegen",
    "open": "Öffnen",
    "amountTotalWithoutDeposit": "Gesamtbetrag (ohne Kaution)",
    "amountTransaction": "Rückzahlungs-Betrag",
    "deposit": "Kaution",
    "amountConsumption": "Betrag Verbrauch",
    "amountMisc": "Betrag Sonstiges",
    "statusOpen": "Offen",
    "statusClosed": "Geschlossen",
    "status": "Status",
    "bookingDate": "Buchungsdatum",
    "objectId": "Objekt-Nr.",
    "rent": "Miete",
    "adults": "{adults} Erwachsener | {adults} Erwachsene",
    "children": "{children} Kind | {children} Kinder",
    "showDeleted": "Gelöschte Buchungen",
    "showDeletedNo": "Nur ungelöschte Buchungen",
    "showDeletedYes": "Alle Buchungen",
    "showDeletedOnly": "Nur gelöschte Buchungen",
    "showCanceledOnly": "Nur stornierte Buchungen",
    "mainInformation": "Details",
    "noOverwrite": "Nicht überschreiben",
    "providerUnknown": "Unbekannt",
    "providers": {
      "STAYIN": "Stayin",
      "HOMEAWAY_DEPRECATED": "FeWo-direkt / HomeAway",
      "HOMEAWAY": "FeWo-direkt / HomeAway",
      "FEWOSCOUT": "fewoscout",
      "FERIENHAUSMIETE": "ferienhausmiete.de",
      "TRAUM_FERIENWOHNUNGEN": "traum-ferienwohnungen.de",
      "OSTSEEKLAR": "ostseeklar.de",
      "FERIENWOHNUNGEN": "ferienwohnungen.de",
      "KOMM_ZUR_SEE": "komm-zur-see",
      "OSTSEE_FERIENWOHNUNGEN": "ostsee-ferienwohnungen.de",
      "BELLMUNDO": "Bellmundo",
      "TOMAS": "Tomas",
      "SECRA": "FeWoNetMix",
      "MEIN_MONTEURZIMMER": "mein-Monteurzimmer.de"
    },
    "contract": "Mietvertrag",
    "type": "Buchungs-Typ",
    "provider": "Provider",
    "bookingPeriod": "Zeitraum",
    "provisionDate": "Provisionsabrechnung im",
    "provisionSettlement": "Provisionsabrechnung",
    "settleSettlement": "Endabrechnung",
    "settleDate": "Endabrechnung im",
    "settleDateOld": "Vorheriges Datum Endabrechnung: {date}",
    "settleDoneTrue": "Abgerechnet",
    "settleDoneFalse": "Ausstehend",
    "settleNotNeeded": "Nicht notwendig",
    "settledUpIn": "Abgerechnet im",
    "noSettleBecauseCanceledHelp": "Die Buchung wurde storniert und läuft deshalb nicht in die Endabrechnung mit ein",
    "rentalPaymentDueDate": "Datum Mietzahlung",
    "guestCount": "Anzahl Gäste",
    "isOnlineBooking": "Online-Buchung",
    "isOfflineBooking": "Offline-Buchung",
    "emails": {
      "owner": "Eigentümer-Benachrichtigung"
    },
    "payment": {
      "amount": "Betrag",
      "type": "Typ",
      "types": {
        "PRE_PAYMENT_OR_FULL_PAYMENT": "Anzahlung",
        "FINAL_PAYMENT": "Restzahlung",
        "DEPOSIT": "Kaution",
        "BOOKING_FEE": "Servicegebühr",
        "VISITOR_TAX": "Kurabgabe"
      },
      "date": "Datum"
    },
    "extraService": {
      "name": "Name",
      "count": "Anzahl",
      "price": "Betrag"
    },
    "emailInformation": "E-Mails",
    "paymentInformation": "Zahlungen",
    "notesInformation": "Notizen",
    "notesStayin": "Stayin Notiz",
    "notesAdditional": "Zusätzliche Notiz",
    "notesCaretaker": "Objektverwalter Notiz",
    "extraServicesInformation": "Extras",
    "invoiceInformation": "Abrechnung",
    "invoice": {
      "total": "Total",
      "rent": "Miete",
      "additionalServices": "Zusätzliche Leistungen",
      "cleaning": "Reinigung",
      "pets": "Haustiere",
      "bookingFee": "Servicegebühr",
      "prepayment": "Anzahlung",
      "providerCommission": "Vertriebsplattform Provision",
      "prePaymentProviderCommission": "davon als Anzahlung",
      "cancellationFee": "Stornokosten",
      "cancellationFeeExternal": "Stornokosten (extern)"
    },
    "noContract": "Kein Mietvertag",
    "consumptionInformation": "Verbrauch",
    "consumption": {
      "consumption": "Verbrauch",
      "amount": "Betrag",
      "noConsumptionAccrued": "Kein Verbrauch angefallen",
      "noConsumptionAvailable": "Keine Verbauchskosten notwendig",
      "old": "Alt",
      "new": "Neu",
      "type": "Typ"
    },
    "transactionInformation": "Rückerstattung",
    "transactionAmount": "Rückerstattung",
    "openTransaction": "Eine Rückzahlung wurde noch nicht abgeschlossen",
    "guestBankDetailsMissing": "Bankdaten des Gastes sind unvollständig",
    "missingDeposit": "Kaution wurde noch nicht vollständig bezahlt",
    "validationErrorCodes": "Hinweise",
    "provisionInformation": "Provision",
    "provision": {
      "net": "Netto",
      "vat": "MwSt.",
      "gross": "Brutto",
      "rent": "Miete",
      "additionalServices": "Zusätzliche Leistungen",
      "pets": "Haustiere",
      "feePerBooking": "pro Buchung"
    },
    "newBookings": "Neue Buchungen",
    "newBookingsHelp": "Hier finden Sie alle Buchungen, die seit Ihrem letzten Export neu ins System gekommen sind",
    "cancel": "Stornieren",
    "confirmCancel": "Sind Sie sicher, dass Sie die Buchung stornieren möchten? Die Buchung wird geschlossen und fließt nur in die Provisionsabrechnung ein. Das Provisionsdatum wird auf heute gesetzt, falls das Abreisedatum in der Zukunft liegt.\nEtwaige Rückzahlungen an den Gast müssen manuell getätigt werden.",
    "canceled": "Storniert",
    "cancellation": "Storno | Stornos",
    "canceledBooking": "Diese Buchung wurde storniert",
    "delete": "Buchung löschen",
    "deleteConfirm": "Sind Sie sicher, dass Sie die Buchung {bookingId} löschen möchten? Die Buchung fließt daraufhin in keine Abrechnung mehr ein.",
    "uncancel": "Stornierung aufheben",
    "uncancelHelp": "Bitte wählen Sie das neue Datum, an dem diese Buchung abgerechnet werden soll. Sollte bereits eine Abrechnung zum gewählten Monat existieren, müssen Sie diese manuell erneuern. Sollte die existierende Abrechnung bereits versendet worden sein, müssen Sie die Abrechnung zuvor manuell als \"nicht gesendet\" markieren.",
    "surveyInformation": "Umfrage",
    "surveyNotCreated": "Die Umfrage für diese Buchung wurde noch nicht angelegt",
    "filterOnlyCanceledInStayin": "Zeige nur offene Stornierungen",
    "isOnlyCanceledInStayin": "Die Buchung ist bereits im Stayin storniert",
    "extendedBookingId": "Verlängerung der Buchung"
  },
  "consumption": {
    "consumptions": "Verbrauchskosten / Nebenkosten",
    "types": {
      "ELECTRICITY": "Strom",
      "ELECTRICITY_LOW_TARIFF": "Strom (Niedertarif)",
      "WATER": "Wasser",
      "GAS": "Gas"
    },
    "typeUnits": {
      "ELECTRICITY": "kWh",
      "ELECTRICITY_LOW_TARIFF": "kWh",
      "WATER": "m³",
      "GAS": "m³"
    }
  },
  "guest": {
    "guest": "Gast",
    "firstName": "Vorname",
    "lastName": "Nachname",
    "guests": "Gäste",
    "name": "Name",
    "address": "Adresse",
    "email": "E-Mail",
    "phone": "Telefon",
    "contact": "Kontakt",
    "id": "Gast-Nr.",
    "mobilePhone": "Telefon (mobil)",
    "street": "Straße",
    "zipcode": "Postleitzahl",
    "city": "Ort",
    "country": "Land",
    "nameOfGuest": "Name des Gasts",
    "guestData": "Gastdaten",
    "receivePromotionMails": "Werbemails versenden"
  },
  "emailSettings": {
    "fromEmail": "Absender-Email",
    "fromName": "Absender-Name",
    "replyName": "Antwort-Email",
    "replyEmail": "Antwort-Name",
    "cc": "CC",
    "bcc": "BCC",
    "subject": "Betreff",
    "body": "Inhalt",
    "footer": "Signatur",
    "availableTemplateVariables": "Mögliche Platzhalter",
    "templateVariableUserName": "Ihr Name",
    "closingName": "Name in Grußformel",
    "closingNameHelp": "Wenn leer wird der aktuelle Benutzername verwendet",
    "to": "Empfänger",
    "sentAt": "Gesendet am",
    "showEmail": "E-Mail ansehen",
    "status": "Status",
    "statusSent": "Gesendet",
    "statusPending": "In Zustellung",
    "statusError": "Fehler",
    "statusCanceled": "Abgebrochen",
    "lastTriedAt": "Zuletzt versucht am",
    "attachments": "Anhänge",
    "footerHelp": "Signatur für E-Mail und PDF. Wird auch als Absenderadresse in PDF-Abrechnungen verwendet."
  },
  "misc": {
    "addCashflow": "In Eigentümerabrechnung berücksichtigen",
    "miscsObject": "Zusatzrechnungen",
    "miscsObjectRecurring": "Wiederkehrende Zusatzrechnungen",
    "miscsBooking": "Weitere Beträge",
    "object": "Objektname",
    "settleDate": "Abrechnung",
    "description": "Beschreibung",
    "receiptField": "Belegfeld",
    "price": "Betrag",
    "tax": "MwSt.",
    "newMiscBooking": "Neuer weiterer Betrag",
    "newMiscObject": "Neue Zusatzrechnung",
    "confirmDuplicate": "Doppelte Zusatzrechnung bestätigen",
    "confirmPositiveAmountTitle": "Positiven Zahlungsbetrag bestätigen",
    "confirmPositiveAmount": 'Sie haben einen positiven Betrag in Höhe von {amount} eingegeben. Sind Sie sicher, dass Sie dem Eigentümer {amount} gutschreiben möchten?',
    "priceGross": "Betrag (Brutto)",
    "taxIfAvailable": "MwSt. (wenn vorhanden)",
    "settleDone": "Status",
    "settleDoneTrue": "Abgerechnet",
    "settleDoneFalse": "Ausstehend",
    "filter": {
      "settleDone": "Nur Ausstehend"
    },
    "deleteMiscObject": "Zusatzrechnung löschen",
    "deleteMiscBooking": "Betrag löschen",
    "editMiscObject": "Zusatzrechnung bearbeiten",
    "editMiscBooking": "Betrag bearbeiten",
    "priceNet": "Nettobetrag",
    "vatPercent": "MwSt. in Prozent",
    "onlyForGrossCalculation": "Nur für Brutto Berechnung",
    "account": "Konto",
    "accounts": "Konten",
    "accountNbr": "Konto-Nr",
    "accountDelete": "Konto löschen",
    "accountEdit": "Konto bearbeiten",
    "accountCreate": "Konto anlegen",
    "forSettlementMonthYear": "Abrechnung (Monat / Jahr)",
    "calculateTaxFromNet": "Aus Nettobetrag berechnen",
    "recurring": {
      "descriptionTemplate": "Beschreibung",
      "newMisc": "Neue wiederkehrende Zusatzrechnung",
      "editMisc": "Wiederkehrende Zusatzrechnung bearbeiten",
      "from": "Start",
      "to": "Ende (inkl.)",
      "interval": "Intervall",
      "notes": "Notizen (nur intern sichtbar)"
    }
  },
  "transaction": {
    "transaction": "Rückzahlung | Rückzahlungen",
    "id": "ID",
    "status": "Status",
    "downloadedAt": "Heruntergeladen am",
    "downloadedNever": "Nie",
    "statusReady": "Ausstehend",
    "statusDownloaded": "Abgeschlossen",
    "downloadSepa": "Rückzahlung als SEPA herunterladen",
    "filterByStatus": "Nach Status filtern...",
    "transactionsMissing": "Fehlend",
    "transactionsNotNeeded": "Nicht notwendig",
    "transactionsCreatedAndDone": "Vorbereitet / Abgeschlossen",
    "delete": "Rückzahlung löschen",
    "deleteConfirm": "Sind Sie sicher, dass Sie die Rückzahlung für Buchung {bookingId} löschen möchten?",
    "markBookingsRefundAsNotNeeded": "0-er Rückzahlungen als erledigt markieren",
    "markBookingsRefundAsNotNeededHelp": "Markiert automatisch alle fehlenden Rückzahlungen als erledigt, bei denen der Rückzahlungsbetrag 0,- ist. Buchungen mit Hinweisen (bspw. Notiz vorhanden oder Verbräuche noch offen) sowie Stornierungen werden dabei ignoriert und müssen manuell erledigt werden.",
    "mailStatus": "E-Mail an Gast",
    "statusGuestMailNotYetDownloaded": "Rückzahlung wurde noch nicht heruntergeladen oder als erledigt markiert",
    "amountConsumptions": "Betrag Verbrauch",
    "amountMiscs": "Betrag Sonstige Kosten",
    "miscsList": "Beschreibung der sonstigen Kosten, mit Komma aufgezählt",
    "amountDeposit": "Betrag Kaution",
    "amountRefund": "Betrag Rückzahlung",
    "amountRefundAbsolute": "Betrag Rückzahlung (als positiver Wert)",
    "downloadPdf": "PDF herunterladen",
    "statusGuestMailNotNeeded": "Nicht notwendig",
    "statusGuestMailMissing": "E-Mail muss noch versendet werden",
    "setGuestMailStatusNotNeeded": "Setze Gast-E-Mail als nicht notwendig",
    "setGuestMailStatusSent": "Setze Gast-E-Mail als bereits gesendet",
    "setGuestMailStatusMissing": "E-Mail an Gast erneut senden",
    "sendGuestMailPaybackByGuest": "Sende Gast-E-Mail mit Nachzahlungsforderung",
    "sendGuestMail": "Sende Gast-E-Mail",
    "markAsCompleted": "Als Abgeschlossen markieren",
    "statusWaitingForDownload": "Wartet auf Herunterladen",
    "statusWaitingForEmail": "Wartet auf E-Mail",
    "statusWaitingForPayback": "Wartet auf Nachzahlung",
    "statusDone": "Abgeschlossen",
    "statusEmailPending": "E-Mail in Zustellung"
  },
  "survey": {
    "disableSending": "Automatischen Umfrageversand deaktivieren",
    "enableSending": "Automatischen Umfrageversand aktivieren",
    "statusNoSurvey": "Automatische Umfrage deaktiviert",
    "statusSurveyMissing": "Ausstehend",
    "statusSurveySent": "Versendet",
    "statusSurveyOpened": "Geöffnet",
    "statusSurveyReplied": "Beantwortet",
    "surveys": "Umfragen",
    "status": "Status",
    "statusBooking": "Buchungsstatus",
    "statusEmail": "Status Versand",
    "sendEmail": "Umfrage jetzt versenden",
    "sendEmailAgain": "Umfrage erneut versenden",
    "showEmail": "E-Mail ansehen",
    "showBooking": "Buchung ansehen",
    "edit": "Umfrage bearbeiten",
    "question": {
      "question": "Frage | Fragen",
      "answer": "Antwort | Antworten",
      "edit": "Fragen bearbeiten",
      "add": "Frage hinzufügen",
      "delete": "Frage löschen",
      "willBeDeleted": "Wird nach dem Speichern gelöscht",
      "required": "Pflichtangabe",
      "rankable": "Für Objekt-Bestenliste",
      "rankingList": "Objekt-Bestenliste",
      "rankableHelp": "Verwenden Sie diese Frage, um eine Objekt-Bestenliste bereitstellen zu können. Geben Sie jeder Antwortmöglichkeit zu dieser Frage eine Punkte-Wertung. Dadurch kann auf der Statistik-Seite eine Liste der am Besten und Schlechtesten bewertenden Objekte angezeigt werden.",
      "typeMultipleChoice": "Kästchen",
      "typeMultipleChoiceSingle": "Multiple Choice",
      "typeText": "Freitext",
      "typeYesNo": "Ja/Nein",
      "addAnswer": "Antwort hinzufügen",
      "deleteAnswer": "Antwort löschen",
      "preview": "Vorschau",
      "typeTemplates": "Vorlagen"
    },
    "guestPage": {
      "pageTitle": "Bewertung zu Ihrer Buchung {bookingId}",
      "submit": "Bewertung absenden",
      "submitSuccessful": "Vielen Dank! Ihre Antworten wurden erfolgreich übermittelt."
    },
    "firstOpenedAt": "Geöffnet am",
    "answeredAt": "Beantwortet am",
    "viewSurveyResult": "Umfrageergebnis ansehen",
    "surveyResultForBooking": "Umfrage zur Buchung {bookingId}",
    "surveyResult": "Antworten zur Umfrage",
    "surveyFeedback": "Umfrage-Rücklauf",
    "statistic": {
      "noAnswerSelected": "Keine Antwort gewählt",
      "notYetOpened": "Noch nicht geöffnet",
      "sentTotal": "Versendet (Gesamt)",
      "openedTotal": "Geöffnet (Gesamt)",
      "answeredTotal": "Beantwortet (Gesamt)",
      "answeredTotalLong": "{answeredTotal} mal beantwortet",
      "textAnswersCount": "Beantwortet",
      "noTextAnswersCount": "Nicht beantwortet"
    },
    "filterShowDisabled": "Zeige deaktivierte Umfragen",
    "filterCheckoutBefore": "Abreise vor dem",
    "filterByStatus": "Nach Status filtern",
    "questionsPreview": "Stichpunktliste mit den ersten Fragen der Umfrage",
    "hasFilledTextAnswerTitle": "Beinhaltet Freitextantwort durch Gast",
    "hasFilledTextAnswer": "Freitextantwort durch Gast",
    "lastActionAt": "Letzte Aktion am",
    "notAnsweredByGuest": "Frage wurde vom Gast nicht beantwortet",
    "statusSurveyReviewed": "Abgeschlossen",
    "setReviewed": "Als Abgeschlossen markieren",
    "setNotReviewed": "Als noch nicht abgeschlossen markieren",
    "reviewedAt": "Abgeschlossen am",
    "numberOfSurveyResults": "Anzahl der Umfragen",
    "rankingPointsTotal": "Punkte aus allen Umfragen",
    "ratingAverage": "Punkte-Wertung",
    "showResultAnswersForObject": "Zeige alle Antworten für dieses Objekt"
  },
  "transactions": {
    "downloadSelectedSepas": "Ausgewählte SEPA Überweisungen herunterladen",
    "downloadSepaPackage": "Ausstehende SEPA Überweisungen herunterladen",
    "selectNotDownloaded": "Markiere Ausstehende",
    "downloadSelectedSepasIncludingAlreadyDownloadedHelp": "Sie haben mindestens eine Rückzahlung zum Heruntergeladen gewählt, die bereits zuvor heruntergeladen wurden. Möchten Sie diese dennoch herunterladen?",
    "createFromBooking": "Rückzahlungen vorbereiten",
    "createFromBookingConfirm": "Rückzahlungen für gewählte Buchungen vorbereiten?",
    "createFromBookingFailedBookingResultsHelp": "Für folgende Buchungen konnten keine Rückzahlungen erzeugt werden",
    "markAsNotNeeded": "Als erledigt markieren"
  },
  "user": {
    "settings": "Benutzereinstellungen",
    "settingsEmail": "E-Mail Einstellungen",
    "users": "Benutzer",
    "email": "E-Mail",
    "firstname": "Vorname",
    "surname": "Nachname",
    "role": "Rolle",
    "roles": {
      "none": "Keine",
      "admin": "Administrator",
      "manager": "Verwalter",
      "user": "Benutzer",
      "caretaker": "Objektverwalter",
      "survey_reviewer": "Umfragen auswerten"
    },
    "impersonate": "Als Nutzer anmelden",
    "lastLogin": "Letzer Login",
    "userManagement": "Benutzerverwaltung",
    "settingsGeneral": "Benutzerdaten",
    "password": "Passwort",
    "passwordHelp": "Leer lassen für keine Änderung",
    "passwordConfirm": "Passwort wiederholen",
    "create": "Benutzer anlegen",
    "mainUser": "Hauptbenutzer",
    "confirmDelete": "Sind Sie sicher, dass Sie den Benutzer löschen möchten?",
    "user": "Benutzer | Benutzer",
    "settingsGuestCommunication": "Gäste-Kommunikation",
    "settingsBookingRefundTransactionGuest": "Rückzahlung an Gast",
    "settingsBookingRefundTransactionGuestHelp": "Nach erfolgter Kautionsrückzahlung wird dem Gast eine Abrechnung als PDF per E-Mail zugesendet. Mithilfe folgender Textblöcke können die Inhalte der E-Mail und des PDF angepasst werden:",
    "settingsGuestSurvey": "Umfrage an Gast"
  },
  "notifications": {
    "successfully_saved": "Erfolgreich gespeichert",
    "successfully_deleted": "Erfolgreich gelöscht",
    "numberOfActive": "Keine neuen Nachrichten | Neue Nachricht | Neue Nachrichten",
    "errorLoading": "Fehler beim Laden der Nachrichten",
    "showAll": "Zeige alle Nachrichten",
    "type": {
      "couldNotSendMail": "E-Mail konnte nicht versendet werden",
      "newCanceledBooking": "Neue stornierte Buchung",
      "newObject": "Neues Objekt wurde importiert",
      "newSurveyResult": "Neues Umfrage-Ergebnis durch Gast",
      "stayinImportJobFailed": "Fehler beim Importieren aus Stayin",
      "couldNotPrepareBookingOwnerMail": "Buchungsbenachrichtigung konnte nicht an Eigentümer versendet werden"
    },
    "status": {
      "active": "Offen",
      "silenced": "Vorrübergehend ignoriert",
      "handled": "Erledigt"
    },
    "setHandled": "Als erledigt markieren",
    "setSilentUntilFor": "Erneut erinnern",
    "notification": "Nachricht | Nachrichten",
    "typeLabel": "Typ",
    "message": "Nachricht",
    "lastNotifiedAt": "Zuletzt aufgetreten am",
    "statusLabel": "Status",
    "silentUntil": "Erneut erinnern",
    "notifiedCount": "Anzahl aufgetreten",
    "context": "Kontext"
  },
  "userSettings": {
    "import": "Buchungsimport",
    "importBookingsOnlyIfAmountAvailableHelp": "Importiert nur Buchungen, deren Betrag größer als 0,- ist",
    "importBookingsOnlyIfFirstPaymentDateHelp": "Importiert nur Buchungen, die ein Anzahlungs- oder Mietzahlungsdatum haben",
    "surveyActivated": "Automatischen Umfrage-Versand aktivieren",
    "bankAccount": "Bankkonto",
    "bankOwner": "Kontoinhaber",
    "bankIban": "IBAN",
    "bankSwift": "BIC",
    "bankSepaCreditorId": "SEPA Creditor ID",
    "importBookingsOnlyIfAmountAvailable": "Aktiviere Betrags-Schwelle",
    "importBookingsOnlyIfFirstPaymentDate": "Aktiviere Anzahlungsdatums-Schwelle",
    "bookingRefundTransactionTemplateGreeting": "Anrede",
    "bookingRefundTransactionTemplateGreetingHelp": "Anrede in der E-Mail",
    "bookingRefundTransactionTemplateGuestSettlementIncluded": "Einleitungstext",
    "bookingRefundTransactionTemplateGuestSettlementIncludedHelp": "Einleitungstext für E-Mail, um auf den PDF-Anhang hinzuweisen",
    "bookingRefundTransactionTemplateConsumptionsAvailable": "Nebenkosten/Verbrauch vorhanden",
    "bookingRefundTransactionTemplateConsumptionsAvailableHelp": "Wird in der E-Mail verwendet, sofern es bei der Buchung zu Nebenkosten in Form von Energieverbrauch kam",
    "bookingRefundTransactionTemplateMiscsGeneralAvailable": "Sonstige Kosten vorhanden",
    "bookingRefundTransactionTemplateMiscsGeneralAvailableHelp": "Wird in der E-Mail verwendet, sofern es bei der Buchung zu sonstigen Kosten ({bookingMiscsText}) kam. Hinweis: es wird nicht unterschieden, ob es sich bei den Kosten u.U. um Schadensersatz handelt.",
    "bookingRefundTransactionTemplateAmountDifferenceTransfered": "Rückzahlung erfolgt",
    "bookingRefundTransactionTemplateAmountDifferenceTransferedHelp": "Wird in der E-Mail und im PDF verwendet, um den Gast darauf hinzuweisen, dass die Rückzahlung getätigt wurde",
    "bookingRefundTransactionTemplateAmountDifferenceRequired": "Nachzahlung erforderlich",
    "bookingRefundTransactionTemplateAmountDifferenceRequiredHelp": "Wird in der E-Mail und im PDF verwendet, sofern der Gast eine Nachzahlung zu tätigen hat",
    "settlementTemplateCoverLetter": "Anschreiben Eigentümerabrechnung (E-Mail & PDF)",
    "general": "Allgemein",
    "templateTexts": "Textvorlagen",
    "templateSurveyMailSubject": "E-Mail Betreff",
    "templateSurveyMailCoverLetter": "E-Mail Anschreiben",
    "templateSurveyMailCoverLetterHelp": "Der Link zur Umfrage wird automatisch an die E-Mail anghängt",
    "templateBookingOwnerNotificationMail": "Eigentümer-Benachrichtigung über neue Buchung",
    "templateBookingOwnerNotificationMailHelp": "Wird versendet, sobald die Buchung im Office erscheint und alle Gastdaten vollständig sind. Buchungs- und Gastdaten werden automatisch an die E-Mail angehängt."
  },
  "import": {
    "importStayin": "Stayin Import",
    "lastImport": "Letzter Import",
    "start": "Import starten",
    "created": "Erstellt",
    "updated": "Bearbeitet",
    "ignored": "Ignoriert",
    "total": "Insgesamt",
    "result": "Ergebnis",
    "never": "Noch Nie",
    "currentlyRunning": "Es läuft bereits ein Import seit dem {since}",
    "ignoredByNotBlocked": "Diese Buchungen sind nicht blockiert",
    "ignoredByPaymentBookings": "Für diese Buchungen ist keine An- oder Vollzahlung vorhanden",
    "ignoredByRentBookings": "Die Mietkosten dieser Buchungen betragen 0,-",
    "updatedBookings": "Diese Buchungen wurden komplett aktualisiert",
    "updatedEssentialsOnlyBookings": "Bei diesen Buchungen wurden nur die Zahlungen aktualisiert. (Durch '@:booking.noOverwrite')"
  },
  "statistic": {
    "count": "Anzahl"
  }
};
